import { Injectable } from '@angular/core';
import { SnotifyService, SnotifyPosition, SnotifyToastConfig } from 'ng-snotify';

enum Messages {
  Success = 'Action was successful',
  Error = 'Action was unsuccessful',
  Info = 'Failed to inform'
}

enum Titles {
  Success = 'Success',
  Error = 'Error',
  Info = 'Info'
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
    public static instance: NotificationService;
    private timeout = 3000;
    private position: SnotifyPosition = SnotifyPosition.rightTop;
    private progressBar = false;
    private closeClick = true;
    private newTop = true;
    private backdrop = -1;
    private dockMax = 8;
    private blockMax = 6;
    private pauseHover = true;
    private titleMaxLength = 100;
    private bodyMaxLength = 500;

    constructor(
        private _snotifyService: SnotifyService
    ) { 
        NotificationService.instance = this;
    }

    private getConfig(): SnotifyToastConfig {
        this._snotifyService.setDefaults({
        global: {
            newOnTop: this.newTop,
            maxAtPosition: this.blockMax,
            maxOnScreen: this.dockMax,
        }
        });
        return {
        bodyMaxLength: this.bodyMaxLength,
        titleMaxLength: this.titleMaxLength,
        backdrop: this.backdrop,
        position: this.position,
        timeout: this.timeout,
        showProgressBar: this.progressBar,
        closeOnClick: this.closeClick,
        pauseOnHover: this.pauseHover
        };
    }

    // write a decorator to overload this method
    public success(message?: string, title?: string): void {
        this._snotifyService.success(message || Messages.Success, title || Titles.Success, this.getConfig());
    }

    public error(message?: string, title?: string): void {
        this._snotifyService.error(message || Messages.Error, title || Titles.Error, this.getConfig());
    }

    public info(message?: string, title?: string): void {
        this._snotifyService.info(message || Messages.Info, title || Titles.Info, this.getConfig());
    }
}
